// CSS
import './plugins/magnify-loupe/magnify.css';
import './plugins/magnific/magnific-popup.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './css/font-awesome.css';
import './js/nouislider/nouislider.min.rem.css';
import 'select2/dist/css/select2.min.css';
import './js/jquery.autocomplete/jquery.autocomplete.css';
import './js/pannellum/pannellum.css';
import 'tippy.js/dist/tippy.css';
import './js/bootstrap-datetimepicker/bootstrap-datetimepicker.min.css';
import 'plugins/cookie-bar/cookie-bar.css';
import './css/styles.css';

// JS
import netteForms from 'nette-forms';
import './js/popper.min.js';
import './js/bootstrap.min.js';
import 'plugins/nette.ajax/nette.ajax.js';
import './js/netteForms.min.js';
import 'plugins/jquery-match-height/jquery.matchHeight.js';
import 'plugins/cookie-bar/cookie-bar.js';
import './plugins/magnific/jquery.magnific-popup.min.js';
import './js/jquery.sticky-kit.min.js';
import './js/ResizeSensor.js';
import 'sticky-sidebar/dist/jquery.sticky-sidebar.min.js';
import './plugins/zoom-master/jquery.zoom.js';
import './plugins/magnify-loupe/jquery.magnify.js';
import 'slick-carousel/slick/slick.min.js';
import './js/nouislider/wNumb.min.js';
import './js/nouislider/nouislider.min.js';
import 'select2/dist/js/select2.min.js';
import './js/jquery.autocomplete/jquery.autocomplete.min.js';
import './js/countdown/jquery.plugin.min.js';
import './js/countdown/jquery.countdown.min.js';
import './js/countdown/jquery.countdown-cs.js';
import './js/components/search.js';
import './js/components/searchLight.js';
import './js/components/installmentCalculator.js';
import './js/components/installmentCalculatorEshop.js';
import './js/components/installmentCalculatorCar.js';
import './js/components/carDetail.js';
import './js/components/eshop.js';
import './js/components/reviews.js';
import './js/components/forms.js';
import './js/components/fileDropZone.js';
import './js/components/vipBuyout.js';
import './js/components/reclamation.js';
import './node_modules/@popperjs/core/dist/umd/popper.min.js';
import 'tippy.js/dist/tippy.umd.min.js';
import './js/bootstrap-datetimepicker/moment.min.js';
import './js/bootstrap-datetimepicker/moment.cs.js';
import './js/bootstrap-datetimepicker/bootstrap-datetimepicker.min.js';
import './js/main.js';

netteForms.initOnLoad();
